export const createTextareaForText = (shape, shapeRefs, transformerRef, stageRef, setFloorPlans, selectedArea) => {
    const textNode = shapeRefs.current[shape.id];
    console.log(textNode)
    //console.log(shapeRefs)
    textNode.hide();
    transformerRef.current.hide();
    textNode.getLayer().batchDraw();

    const stage = stageRef.current;
    const textPosition = textNode.getAbsolutePosition();
    const stageBox = stage.container().getBoundingClientRect();
    const scale = stage.scaleX();

    const areaPosition = {
        x: stageBox.left + textPosition.x,
        y: stageBox.top + textPosition.y,
    };

    const textarea = document.createElement("textarea");
    document.body.appendChild(textarea);
    
    textarea.value = shape.text;
    textarea.style.position = 'absolute';
    textarea.style.top = `${areaPosition.y}px`;
    textarea.style.left = `${areaPosition.x}px`;
    textarea.style.width = `${(shape.width || 150) * scale}px`;
    textarea.style.fontSize = `${14 * scale}px`;
    textarea.style.border = '1px dashed white';
    textarea.style.padding = `${4 * scale}px`;
    textarea.style.lineHeight = textNode.lineHeight();
    textarea.style.fontFamily = textNode.fontFamily();
    textarea.style.margin = '0px';
    textarea.style.overflow = 'hidden';
    textarea.style.textAlign = 'center';
    textarea.style.color = 'white';
    textarea.style.background = 'transparent';
    textarea.style.outline = 'none';
    textarea.style.resize = 'none';
    textarea.style.zIndex = 9999;
    textarea.style.boxSizing = 'border-box';
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;

    textarea.focus();

    const finishEditing = () => {
        const updatedText = textarea.value.trim();

        if (updatedText === "") {
            setFloorPlans((prevPlans) => {
                const updated = prevPlans[selectedArea?.id]?.filter((s) => s.id !== shape.id);
                return { ...prevPlans, [selectedArea?.id]: updated };
            });
        } else {
            updateTextShape(shape.id, updatedText, setFloorPlans, selectedArea);
        }

        document.body.removeChild(textarea);
        textNode.show();
        transformerRef.current.show();
        textNode.getLayer().batchDraw();
    };

    textarea.addEventListener("blur", finishEditing);
    textarea.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            finishEditing();
        }
    });
    textarea.addEventListener("input", () => {
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
    });
};

const updateTextShape = (id, newText, setFloorPlans, selectedArea) => {
    setFloorPlans((prevPlans) => {
        const updated = prevPlans[selectedArea?.id]?.map((shape) =>
            shape.id === id && shape.type === "text" ? { ...shape, text: newText } : shape
        );
        return { ...prevPlans, [selectedArea?.id]: updated };
    });
};
